import { render, staticRenderFns } from "./ActualGroups.vue?vue&type=template&id=4321e712"
import script from "./ActualGroups.vue?vue&type=script&lang=js"
export * from "./ActualGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports